// Opens the share sheet (src/client/share/sheet.js), a lazy chunk with its own stylesheet. Used by
// the app, Settings and Study Hall, so it imports nothing stateful. The stylesheet is a file, not a
// <style> tag: Study Hall's CSP only allows styles from Re:Vault's own files.
let sheetUrl = __RVM.shareJs; // a let, so esbuild leaves the import alone
let cssUrl = __RVM.shareCss;
let loading = null;

function load() {
	if (loading) return loading;
	const css = document.createElement("link");
	css.rel = "stylesheet";
	css.href = cssUrl;
	const ready = new Promise((r) => { css.onload = css.onerror = r; });
	document.head.appendChild(css);
	loading = Promise.all([import(sheetUrl), ready]).then(([m]) => m).catch((e) => { loading = null; css.remove(); throw e; });
	return loading;
}

// opts: { title, text, url, message, note, kind: "share" | "invite", from } (all optional; the
// default is the plain "Share Re:Vault" sheet). Resolves false when the sheet could not load.
export function openShareSheet(opts) {
	const from = document.activeElement;
	return load().then((m) => { m.open(Object.assign({ from }, opts || {})); return true; }, () => false);
}
